<template>
<div :class="['recipe-detail', { 'screen-lg': this.onTabletUp }, this.currentView.context]" v-if="recipe">
  <Hero :imageUrl="recipe.imageURL" type="inset" />
  <div class="detail-content-container">
    <h2 class="recipe-title">
      <small v-if="hasMacros">
        {{ $t('lblCalories') }} {{ formattedMacro(recipe, 'calories').unit }} • {{ $t('lblCarbs') }} {{ formattedMacro(recipe, 'carbs').unit }} •
        {{ $t('lblProtien') }} {{ formattedMacro(recipe, 'protein').unit }} • {{ $t('lblFat') }} {{ formattedMacro(recipe, 'fat').unit }}
      </small>
      {{ recipe.title }}
    </h2>

    <div class="auth-btn-wrapper">
      <BaseButton type="button" class="btn-small btn-auth" @click="toLogin">{{ $t('lblSignInAddToPlan') }}</BaseButton>
    </div>

    <div class="detail-section">
      <div class="detail-section">
        <h3>{{ $t('recipes.lblIngredients') }}</h3>
        <div v-if="recipe.ingredients.length" class="ingredient-item" v-for="(ingredient, index) in recipe.ingredients" :key="'ingredient' + index">
          <div class="ingredient" v-if="ingredient && ingredient.metricInfo">
            <span v-if="ingredient.metricInfo.name && ingredient.count">{{ ingredient.count }} {{ ingredient.metricInfo.name }}</span>
            {{ `${' ' + ingredient.name} ${ingredient.preparation ? ingredient.preparation : ''}` }}
          </div>
        </div>
      </div>

      <div class="instructions">
        <h3>{{ $t('recipes.lblInstructions') }}</h3>
        <div class="instruction-item" v-for="(instruction, index) in recipe.instructions" :key="'instruction' + index">
          <div class="instruction">
            {{ `${instruction.step}.` }}
            {{ `${instruction.description}` }}
          </div>
        </div>
      </div>
    </div>

    <NutritionTable :title="$t('recipes.lblNutritionalInformation')" :elements="getNutrition"></NutritionTable>
  </div>
</div>
</template>

<script>
import store from '@state/store';
import utils from '@src/utils/utils';
import { macrosMixin } from 'macrosMixin';
import NutritionTable from '../Recipes/NutritionTable';
import Hero from '../Hero/Hero';
import {
  errorsComputed,
  errorsMethods,
  kitchenDrawerComputed,
  kitchenDrawerMethods,
  planMethods,
  dishesMethods,
  recipesMethods,
  primaryNavComputed,
  primaryNavMethods,
  groceryListMethods,
  shareMethods,
} from '@state/helpers';

export default {
  mixins: [macrosMixin],
  components: {
    Hero,
    NutritionTable,
  },
  props: {
    isEmbed: {
      type: Boolean,
    },
    data: {
      type: Object,
    },
    onTabletUp: {
      type: Boolean,
    },
  },
  data() {
    return {
      adjustedServes: 0,
      message: 'Text to copy...',
    };
  },
  computed: {
    ...kitchenDrawerComputed,
    ...primaryNavComputed,
    currentView() {
      return this.navContent[this.activeNavIndex];
    },
    currentPrimaryView() {
      return this.primaryNavContent[this.activePrimaryNavIndex];
    },
    isPrimaryPlanView() {
      return this.currentPrimaryView.primary && this.currentPrimaryView.component === 'Plans';
    },
    recipe() {
      return this.data;
    },
    getNutrition() {
      return this.data.nutritionDigest || [];
    },
    hasMacros() {
      if (this.recipe.aggregatedNutritionDigest && recipe.macroNutritionDiges) {
        return (this.recipe.aggregatedNutritionDigest && Object.keys(this.recipe.aggregatedNutritionDigest.macroNutritionDigest).length) ||
          Object.keys(this.recipe.macroNutritionDigest).length
          ? true
          : false;
      } else {
        return false;
      }
    },
  },
  mounted() {},
  methods: {
    toLogin() {
      this.$router.replace({ name: 'login' });
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'theme.scss';

.recipe-detail {
  @extend %scrollable-drawer-content;

  background-color: $color-recipe-detail-bg;
  padding-bottom: 6rem;

  .detail-content-container {
    padding: 0 1.6rem 10rem;

    .recipe-title {
      color: $color-meal-card-horizontal-title;
      line-height: 2.475rem;
      margin-bottom: 1.5rem;

      small {
        color: $color-meal-card-horizontal-subtitle;
        display: block;
        font-size: 70%;
      }
    }

    .auth-btn-wrapper,
    .share-btn-wrapper {
      display: flex;
      justify-content: center;
      margin-bottom: 2rem;
    }

    .btn-secondary {
      margin-bottom: 2rem;
    }

    .detail-section {
      margin-bottom: 3.2rem;
    }
  }

  h3 {
    color: $color-grey;
    font-weight: 600;
    margin-bottom: 1.5rem;
  }

  .ingredient-item {
    color: $color-lightGrey;
    font-size: 1.6rem;
    line-height: 2rem;
    margin-bottom: 2rem;
  }

  .instructions {
    .instruction-item {
      margin-top: 0;
      text-align: left;

      .instruction {
        color: $color-lightGrey;
        font-size: 1.4rem;
        letter-spacing: 0.35px;
        line-height: 1.9rem;
        margin-bottom: 2rem;
      }
    }
  }

  &.screen-lg {
    border-bottom-left-radius: 2.5rem;
    border-bottom-right-radius: 2.5rem;

    .detail-content-container {
      padding-bottom: 0;
    }

    &.drawerModal {
      height: 100%;
    }
  }
}
</style>
